import React from 'react';
import Footer from './Footer.tsx';


function About() {

    return (

        <div className="font-sans min-h-screen flex flex-col bg-gradient-to-r from-[#EDEDED] to-[#D9D9D9] rounded-b-3xl">

            <div className="flex-1 py-8 px-4 max-w-screen-lg mx-auto">

                <h1 className="text-4xl md:text-6xl mb-[60px] md:mb-[112px] font-serif">About Us</h1>



                <p className="mb-2 text-xl md:text-2xl text-left font-bold">About Us</p>



                <p className="mb-6 text-left leading-[24px] md:leading-[26px]">

                    At   <a href="https://paritycalculator.com/" className="underline ml-1 mr-1" target="blank">paritycalculators.com</a>comprise a team of three devoted professionals who established an easy-to-use financial insights platform for all users. Through our SaaS startup experience we recognized that money value assessment across nations and time durations and currencies stands essential for personal and commercial financial needs. Most digital tools used to compare finances exist with either complex interfaces or outdated and unreliable information sources. Using our merged experience in UX/UI design and full-stack development and SEO and digital marketing we created a modern financial calculator platform devoted to user experience while being dependable and easy to use.


                </p>



                <p className="mb-2 text-left">Our team consists of:</p>



                <ul className="list-disc ml-6 mb-6 text-left leading-[24px] md:leading-[26px]">

                    <li className="mb-3">The UX/UI designer maintains a platform which combines clear user interactions with visual sophistication and easy accessibility. All user interactions have been thoughtfully designed by our team to grant a seamless experience for people who use our services.</li>

                    <li className="mb-3">The full-stack developer delivers advanced technical expertise to our platform by maintaining efficient tool operation with precise calculations using real-time data processing.</li>

                    <li className="mb-3">The marketing specialist focuses on SEO to guarantee our platform reaches audience targets. Our tools become accessible worldwide through our SEO optimization combined with digital marketing and strategic content creation efforts.
                    </li>

                </ul>



                <p className="text-left leading-[24px] md:leading-[26px]">

                The combined mission directs us to distribute financial expertise that creates smarter choices for every person and business researcher and traveler. We create tools that provide exact and relevant information about money purchasing strength between nations as well as inflation's impact on savings and currency conversion using real-time rates. We maintain ongoing development of our platform which helps us lead market trends so our users experience the best possible outcome.                     <a href="https://paritycalculator.com/" className="underline ml-1 mr-1" target="blank">paritycalculators.com</a>
                strives to offer easy accessible financial literacy to everybody through simplified content.
                    
                     
                     
                    

                </p>

            </div>

            <Footer />

        </div>

    );

}



export default About;